import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';
import l from '../../../../lang';
import './styles.scss';
import Input from '../../../common/input';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import SelectBeneficiary from '../select-beneficiary';
import { postRequestSettlement } from '../../../../store/settlements/actions';
import Loading from '../../../common/loading';
import MessageError from '../../../common/message-error';
import { getBalances } from '../../../../store/home/actions';
import SuccessfulAnimation from '../../../common/successful-animation';
import Message from '../../../common/message';
import { MessageTypes } from '../../../../constants';
import { scrollIntoView } from '../../../../utils';
import Dialog from '../../../common/dialog';
import config from '../../../../config';

const RequestSettlemet = ({
  loading,
  error,
  errorInfo,
  requestSuccess,
  availableBalance,
  loadingBalances,
  functionalCurrency,
  settlementEnabled,
  settlementFeeEnabled,
  fnGetBalances,
  fnRequestSettlement,
}) => {
  const [showErrors, setShowErrors] = useState(false);
  const [amount, setAmount] = useState(0);
  const [beneficiaryId, setBeneficiaryId] = useState('');
  const errorRef = useRef(null);
  const beneficiariesRef = useRef(null);
  const [confirmMessage, setConfirmMessage] = useState(false);

  useEffect(() => {
    fnGetBalances();
  }, [fnGetBalances]);

  useEffect(() => {
    if (availableBalance) {
      setAmount(availableBalance);
    }
    // eslint-disable-next-line
  }, [availableBalance]);

  useEffect(() => {
    if (error) {
      scrollIntoView(errorRef);
    }
  }, [error]);

  return (
    <div className="request-settlement">
      {(loading || loadingBalances) && <Loading fullScreem />}
      {requestSuccess && (
        <div className="request-settlement__success">
          <SuccessfulAnimation text={l('requestSettlement.success')} />
        </div>
      )}
      {!requestSuccess && (
        <>
          <div className="request-settlement__container">
            {amount > 0 && !settlementEnabled && (
              <div className="request-settlement__kyc-review">
                <Message type={MessageTypes.WARNING} body={l('requestSettlement.withdrawalsDisabled')} />
              </div>
            )}
            {settlementFeeEnabled && (
              <div className="request-settlement__desc">
                {l('requestSettlement.desc', config.minWithdrawalUSD, config.chargeWithdrawalUSD)}
              </div>
            )}
            <div className="request-settlement__amount">
              <Input
                type="number"
                name="amount"
                label={l('requestSettlement.amount')}
                onChange={e => setAmount(e.target.value)}
                prefix={functionalCurrency}
                value={amount}
                disabled
                error={showErrors && amount <= 0 ? l('requestSettlement.amount.noAvailable') : null}
              />
            </div>
            <SelectBeneficiary
              disabled={!settlementEnabled}
              value={beneficiaryId}
              onSelect={val => setBeneficiaryId(val)}
              errorReference={beneficiariesRef}
              externatError={showErrors && amount > 0 && !beneficiaryId ? l('beneficiary.isRequired') : null}
            />
            <div ref={errorRef}>
              {error && (
                <div className="request-settlement__error">
                  <MessageError errorInfo={errorInfo} />
                </div>
              )}
            </div>
          </div>
          <div className="request-settlement__btn">
            <ButtonCustom
              text={l('requestSettlement.sendRequest')}
              loading={loading}
              size="full-bottom"
              variant="contained"
              disabled={(amount > 0 && !settlementEnabled) || loading}
              onClick={() => {
                setShowErrors(true);
                if (amount && amount > 0 && beneficiaryId) {
                  if (settlementFeeEnabled && functionalCurrency === 'USD' && amount < config.minWithdrawalUSD) {
                    setConfirmMessage(true);
                  } else {
                    fnRequestSettlement(beneficiaryId);
                  }
                } else {
                  scrollIntoView(beneficiariesRef);
                }
              }}
            />
          </div>
        </>
      )}
      <Dialog
        open={confirmMessage}
        dividers={false}
        title={l('paymentMethod.confirm.title')}
        unpaddingFooter
        unpaddingContent
        body={
          <div className="confirm-body-container">
            {Parser(l('requestSettlement.confirmMessage', config.minWithdrawalUSD, config.chargeWithdrawalUSD))}
          </div>
        }
        footer={
          <div className="confirm-footer-container">
            <ButtonCustom
              text={l('common.cancel')}
              size="half-left"
              onClick={() => setConfirmMessage(false)}
            />
            <ButtonCustom
              name="btn-confirm"
              text={l('common.confirm')}
              variant="contained"
              size="half-right"
              onClick={() => {
                setConfirmMessage(false);
                fnRequestSettlement(beneficiaryId);
              }}
            />
          </div>
        }
      />
    </div>
  );
};

RequestSettlemet.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorInfo: PropTypes.object,
  requestSuccess: PropTypes.bool,
  availableBalance: PropTypes.number,
  loadingBalances: PropTypes.bool,
  functionalCurrency: PropTypes.string,
  settlementEnabled: PropTypes.bool,
  settlementFeeEnabled: PropTypes.bool,
  fnGetBalances: PropTypes.func,
  fnRequestSettlement: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.settlements.loading,
  error: state.settlements.error,
  errorInfo: state.settlements.errorInfo,
  requestSuccess: state.settlements.requestSuccess,
  loadingBalances: state.home.balances.loading,
  availableBalance: state.home.balances.data?.availableBalance,
  functionalCurrency: state.dashboard.merchantMe?.functionalCurrency,
  settlementEnabled: state.dashboard.merchantMe?.settlementEnabled,
  settlementFeeEnabled: state.dashboard.merchantMe?.settlementFeeEnabled,
});

const mapDispatchToProps = dispatch => ({
  fnGetBalances: () => dispatch(getBalances()),
  fnRequestSettlement: beneficiaryId => dispatch(postRequestSettlement(beneficiaryId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestSettlemet);
